import React from 'react';

const ActivityTabBar = ({ activeTab, onTabChange }) => {
  const tabs = [
    { key: 'all', label: 'Attività' },
    { key: 'censimento_arboreo', label: 'Censimento' },
  ];

  return (
    <div className="flex justify-center bg-primary p-2 rounded-lg border-secondary border space-x-3">
      {tabs.map(tab => (
        <button
          key={tab.key}
          onClick={() => onTabChange(tab.key)}
          className={`
            px-4 py-1 rounded-lg font-medium transition
            ${activeTab === tab.key
              ? 'bg-global text-white'
              : 'bg-primary text-gray-300 '}
          `}
        >
          {tab.label}
        </button>
      ))}
    </div>
  );
};

export default ActivityTabBar;
